import { estimationColumns } from "./columnsData/columns";
import { useFormContext, useWatch } from "react-hook-form";
import { Button, Box } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { createShellTasks } from "../../../../../../api/tasksApi";
import {
  useResponsiveShellTable,
  getResponsiveShellTableConfig,
} from "./responsiveShellTable";

// Edge Mentor code labels for the Shell Estimation table (DataGridView7).
// These semantic labels match the Edge Mentor Excel/runtime content.
const SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS = {
  Circ_Weld_Hours: "shellEstCircWeldHours",
  Long_Weld_Hours: "shellEstLongWeldHours",
  Rolling_Hours: "shellEstRollingHours",
  Dishing_Hours: "shellEstDishingHours",
  NDT_Cost: "shellEstNdtCost",
};

const SHELL_ESTIMATION_COLUMN_WEIGHTS = {
  Circ_Weld_Hours: 1,
  Long_Weld_Hours: 1,
  Rolling_Hours: 1,
  Dishing_Hours: 1,
  NDT_Cost: 1,
};

const EstimationTable = (props) => {
  const { isLoading, projectId, equipId } = props;
  const { control, getValues } = useFormContext();
  const watchedRows = useWatch({
    control,
    name: "DataGridView7",
  });

  const { viewportRef, tableWidth, headerFontSize, bodyFontSize, columns } =
    useResponsiveShellTable(estimationColumns, SHELL_ESTIMATION_COLUMN_WEIGHTS);

  const { mrtProps, headCellSx, bodyCellSx, editFieldSx } =
    getResponsiveShellTableConfig({
      tableWidth,
      headerFontSize,
      bodyFontSize,
    });

  const addToTasks = async () => {
    const inputRaw = getValues("DataGridView5");
    const estimation = getValues("DataGridView7");
    // Strip UID before sending to tasks API
    const input = inputRaw?.map((row) => {
      const { UID, ...rest } = row;
      return rest;
    });
    let subCategoryRequest = {
      subCategory: {
        name: "",
        estimatedHours: 0,
        remarks: "",
        invoiceable: false,
        // categoryId: row.id
      },
      users: [],
    };
    console.log(input);
    let categoryRequest = {
      name: "Shell Welding",
      mcsProjectId: projectId,
    };

    await createShellTasks(input, estimation, projectId, equipId);
  };

  return (
    <Box
      ref={viewportRef}
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      <MaterialReactTable
        {...mrtProps}
        columns={columns}
        data={watchedRows ?? []}
        enableSorting={false}
        enableColumnActions={false}
        enableEditing
        editDisplayMode="cell"
        state={{
          isLoading,
        }}
        muiTableHeadCellProps={{
          sx: headCellSx,
        }}
        muiTableBodyCellProps={({ cell }) => ({
          "data-edge-mentor":
            SHELL_ESTIMATION_EDGE_MENTOR_CODE_LABELS[cell.column.id] ||
            undefined,

          sx: bodyCellSx,
        })}
        muiEditTextFieldProps={{
          sx: editFieldSx,
        }}
        renderBottomToolbarCustomActions={() => (
          <Button
            color="primary"
            onClick={() => addToTasks()}
            variant="contained"
            size="small"
          >
            Add to Tasks
          </Button>
        )}
      />
    </Box>
  );
};

export default EstimationTable;
